import {Component, OnInit} from '@angular/core';
import { ModalController, NavController } from "@ionic/angular/standalone";
import { IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonIcon, IonNote, IonGrid, IonRow, IonCol, IonButton } from '@ionic/angular/standalone';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NotificationService} from "../../../services/notification.service";
import {LocalStorageService} from "../../../services/local-storage.service";
import {ModalRoleEnum} from "../../enums/modal-enum";
import {emailRegex} from "../../constants/regex";
import {catchError, finalize, of, switchMap, takeUntil, tap} from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import {ManageErrorService, RequestTypesEnum} from "../../../services/manage-error.service";
import {
  AutenticazioneService,
  LoginResponse, UtentiService


} from "../../../../api-clients/generated/services";
import {LoaderService} from "../../../services/loader.service";
import {PathEnum} from "../../enums/path-enum";
import {UnsubscribeOnDestroy} from "../../abstracts/unsubscribe-on-destroy";
import { UpperCasePipe } from '@angular/common';


@Component({
    selector: 'app-recover-password-modal',
    templateUrl: './recover-password-modal.component.html',
    styleUrls: ['./recover-password-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonIcon, IonNote, IonGrid, IonRow, IonCol, IonButton, FormsModule, ReactiveFormsModule, UpperCasePipe]
})
export class RecoverPasswordModalComponent extends UnsubscribeOnDestroy  implements OnInit {

  modalTitle = 'Recupera Password';
  confirmButtonText = 'Recupera Password';
  cancelButtonText = 'Annulla';
  modalForm: any;
  formGroup: FormGroup = new FormGroup<any>({});
  modalMessage: string = 'Inserire il proprio indirizzo e-mail per chiedere di recuperare la password';
  isConfirmButtonVisible = true;
  isCancelButtonVisible = true;
  errorMessageEmailPattern = 'E-mail non valida'
  // isConfirmRecoverButtonVisible: boolean = true;
  // isConfirmLoginButtonVisible: boolean = false;

  constructor(private modalController: ModalController,
              private fb: FormBuilder,
              private authService: AutenticazioneService,
              private userControllerService: UtentiService,
              private manageErrorService: ManageErrorService,
              private loaderService: LoaderService,
              public navCtrl: NavController,
              private notificationService: NotificationService,
              private localStorageService: LocalStorageService) {
    super();
    this.formGroup = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(new RegExp(emailRegex))]],
      password: [null, Validators.required],
    });
  }

  ngOnInit() {
  }

  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirmRecoverPassword() {
    this.loaderService.showLoaderObserve$().pipe(
      // TODO SERVIZIO PROVVISORIO DA MODIFICA VERIFICARE
      switchMap(() => this.userControllerService.resetUserPasswordForm(this.ctrlEmail().value, '')),
      finalize(() => this.loaderService.hideLoader())
    ).subscribe({
      next: value => {
        this.notificationService.openToast({message: 'Richiesta inviata con successo', color: 'success'});
        this.modalController.dismiss(true, ModalRoleEnum.CONFIRM);
      },
      error: (err: HttpErrorResponse) => {
        this.manageErrorService.manageError(err, RequestTypesEnum.ERRORE_RECUPERA_PASSWORD);
      }
    })
  }

  ctrlEmail() {
    return this.formGroup.get('email') as FormControl;
  }

  ctrlPassword() {
    return this.formGroup.get('password') as FormControl;
  }
}

